"use client";

import { useTranslations } from "next-intl";
import FaqAccordion from "./faq-accordion";

export default function Guvenlik() {
    const t = useTranslations("helpContent");

    return (
        <FaqAccordion
            className="mt-6 mb-8 flex w-full gap-6 rounded-md py-3 lg:mt-8"
            items={[
                {
                    question: t("securityQ1"),
                    answer: (
                        <p>
                            {t.rich("securityA1", {
                                b: (chunks) => <strong>{chunks}</strong>,
                            })}
                        </p>
                    ),
                },
            ]}
        />
    );
}
